import { useEffect, useRef, useState } from 'react';

const services = [
  {
    icon: 'ri-macbook-line',
    title: 'Création de site web',
    cta: 'Créer mon site',
    launchPrice: '500 CHF',
    description:
      'Sites modernes, stratégiques et optimisés pour convertir. Une présence en ligne professionnelle qui attire et rassure vos clients.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Création de logo',
    cta: 'Créer mon identité',
    description:
      'Un logo unique et élégant, pensé pour refléter votre identité et marquer les esprits dès le premier regard.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Supports de communication',
    cta: 'Créer mes supports',
    description:
      'Flyers et cartes de visite modernes, cohérents avec votre image pour une communication professionnelle et impactante.',
  },
  {
    icon: 'ri-instagram-line',
    title: 'Gestion des réseaux sociaux',
    cta: 'Développer ma visibilité',
    description:
      'Stratégie, création de contenu et gestion de vos réseaux pour développer votre visibilité et attirer de nouveaux clients.',
  },
];

export default function Services() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="services"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className={`text-left mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-brand mb-4 block">
            Mes Services
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-medium text-white mb-4">
            Ce que je propose
          </h2>
          <p className="text-white/50 max-w-xl text-base md:text-lg font-light">
            Des solutions digitales complètes pour faire briller votre marque en ligne
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={service.title}
              className={`group flex flex-col glass-card rounded-2xl p-8 transition-all duration-700 hover:scale-[1.02] hover:-translate-y-1 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${0.15 + index * 0.1}s` }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-brand/10 mb-6 group-hover:bg-brand/20 transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-brand`}></i>
              </div>

              <h3 className="text-lg font-display font-medium text-white mb-3">
                {service.title}
              </h3>

              <p className="text-sm text-white/50 leading-relaxed font-light flex-1">
                {service.description}
              </p>

              {'launchPrice' in service && (
                <div className="mt-4 mb-2">
                  <p className="text-[11px] font-semibold tracking-[0.15em] uppercase text-white/40 mb-1">
                    Prix de lancement
                  </p>
                  <p className="text-2xl font-display font-semibold text-brand tracking-tight">
                    {service.launchPrice}
                  </p>
                </div>
              )}

              <button
                onClick={() => {
                  const el = document.getElementById('contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="mt-6 btn-secondary w-full py-2.5 text-xs"
              >
                {service.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}